import Vue from 'vue'
import vuePicturePreview from 'vue-picture-preview'

let elemInstance

export default function preview (src) {
  if (!elemInstance) {
    const wrapper = document.createElement('div')
    document.body.appendChild(wrapper)
    elemInstance = new Vue(vuePicturePreview)
    elemInstance.$props.options = {
      fullscreenEl: false,
      bgOpacity: 0.80
    }
    elemInstance.$mount(wrapper)
  }
  elemInstance.$props.list = [{
    msrc: src,
    src: src
  }]
  elemInstance.show(0)
}
